<template>
  <Modal v-model="showModal" width="1000" footer-hide>
    <p slot="header" class="header">
      <span>2025年执业药师继续教育相关工作安排</span>
    </p>
    <div class="content">
      <p>尊敬的系统用户：</p>
      <br />
      <p>
        根据主管部门统一要求，云南省2025年执业药师继续教育系统将于11月30日24:00关闭，请抓紧时间学习并在截止日期前完成考试，以免影响证书注册和使用！特此提醒！
      </p>
      <p>
        如果您有有任何疑问或需要帮助，可以通过平台官方电话联系，我们将尽力为您提供支持和解答。
      </p>
      <br />
      <p>感谢您的理解和支持！</p>
    </div>
  </Modal>
</template>
<script>
export default {
  name: 'SystemCloseModal',
  components: {},
  filters: {},
  mixins: [],
  props: {},
  data () {
    return {
      showModal: false
    };
  },
  computed: {
    type () {
      return process.env.TYPE;
    }
  },
  watch: {},
  created () {
  },
  mounted () {
  },
  beforeCreate () {
  },
  beforeMount () {
  },
  beforeUpdate () {
  },
  updated () {
  },
  beforeDestroy () {
  },
  destroyed () {
  },
  activated () {
  },
  methods: {}
};
</script>
<style lang="less" scoped>
.header {
  color: #1c2634;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
}

.content {
  display: flex;
  flex-direction: column;
  padding: 20px;

  > img {
  }

  > p {
    font-size: 18px;
    font-weight: 500;
    line-height: 34px;
  }

  > p > span {
      font-weight: 600;
  }

}
</style>
